import {
  GlobalMessages,
  TranslationGlobalMessages
} from "../interfaces/globalMessages";

export const messages: TranslationGlobalMessages = {
  [GlobalMessages.activeText]: "Active",
  [GlobalMessages.inactiveText]: "Inactive",
  [GlobalMessages.yesText]: "Yes",
  [GlobalMessages.noText]: "No",
  [GlobalMessages.filtersText]: "Filters",
  [GlobalMessages.underConstructionText]: "Under construction",
  [GlobalMessages.columnActions]: "Actions",
  [GlobalMessages.buttonAdd]: "Add new",
  [GlobalMessages.buttonEdit]: "Edit",
  [GlobalMessages.buttonDelete]: "Delete",
  [GlobalMessages.buttonRefresh]: "Refresh",
  [GlobalMessages.buttonClose]: "Close",
  [GlobalMessages.buttonPrint]: "Print",
  [GlobalMessages.buttonExport]: "Export",
  [GlobalMessages.buttonCancel]: "Cancel",
  [GlobalMessages.buttonAccept]: "Accept",
  [GlobalMessages.buttonReject]: "Reject",
  [GlobalMessages.buttonSaveChanges]: "Save changes",
  [GlobalMessages.buttonView]: "View",
  [GlobalMessages.buttonHelp]: "Help",
  [GlobalMessages.tooltipFixed]:
    "Fixed records (pre-defined) can not be manipulated",
  [GlobalMessages.noItemsText]: "No items to display",
  [GlobalMessages.clientSelectInstruction]: "Enter at least 3 characters",
  [GlobalMessages.entityClassificationSupplyType]:
    "Classification of supply type",
  [GlobalMessages.entityConcreteBatchingPlant]: "Concrete batching plant",
  [GlobalMessages.entityMeasureUnitType]: "Measure unit type",
  [GlobalMessages.entitySupplier]: "Supplier",
  [GlobalMessages.entityConcreteCharacteristicsType]: "Characteristics type",
  [GlobalMessages.entityGravel]: "Gravel",
  [GlobalMessages.entitySlump]: "Slump",
  [GlobalMessages.entityConcreteRecipeFamilyApplicationType]:
    "Concrete recipe family application type",
  [GlobalMessages.invalidFormInputs]:
    "Fill all required information on the current tab",
  [GlobalMessages.invalidMinEffectiveDate]:
    "The date must be greater than or equal to the active effective date",
  [GlobalMessages.measureUnitCharacteristicMPa]: "MPa",
  [GlobalMessages.emptySelectField]: "None",
  [GlobalMessages.selectClient]: "Select client",
  [GlobalMessages.dayDeliveryText]: "Last deliveries of the day",
  [GlobalMessages.lastConcretingRequestsText]: "Last concreting requests",
  [GlobalMessages.lastContractsText]: "Last contracts",
  [GlobalMessages.searchText]: "Search",
  [GlobalMessages.showMore]: "Show more",
  [GlobalMessages.reversibleAction]: "This action can be reversed later",
  [GlobalMessages.successText]: "Success",
  [GlobalMessages.warningText]: "Warning",
  [GlobalMessages.errorText]: "Error",
  [GlobalMessages.lgpdTitle]: "Data sharing term"
};
